import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {LoadingScreen} from './components/LoadingScreen'
import {AuthInit} from './modules/auth'

const App = () => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <AuthInit>
        <Outlet />
      </AuthInit>
    </Suspense>
  )
}

export {App}
